import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full bg-transparent" }
const _hoisted_2 = { class: "flex lg:justify-between p-3 pb-0 lg:pb-3 lg:border-b dark:border-gray-750" }
const _hoisted_3 = {
  key: 0,
  class: "font-ops"
}
const _hoisted_4 = {
  key: 1,
  class: "font-semibold lg:font-normal ml-1 lg:ml-0"
}
const _hoisted_5 = { class: "h-full p-3 z-0" }
const _hoisted_6 = {
  key: 2,
  class: "w-full mt-4 lg:mt-0 flex justify-center"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Connect your wallet")

import { useTradeState } from '@/composables/trade/useTradeState';
import useBreakpoints from '@/composables/useBreakpoints';
import useTokens from '@/composables/useTokens';
import { configService } from '@/services/config/config.service';
import useWeb3 from '@/services/web3/useWeb3';
import { take } from 'lodash';
import { computed } from 'vue';


export default _defineComponent({
  setup(__props) {

const { appNetworkConfig, isWalletReady, toggleWalletSelectModal } = useWeb3();
const { upToLargeBreakpoint } = useBreakpoints();
const { setTokenInAddress } = useTradeState();
const {
  balanceFor,
  balances,
  dynamicDataLoading: isLoadingBalances
} = useTokens();
const nativeCurrency = configService.network.nativeAsset.symbol;

const etherBalance = computed(() => {
  if (!isWalletReady.value) return '-';
  return Number(balanceFor(appNetworkConfig.nativeAsset.address)).toFixed(4);
});

const tokensWithBalance = computed(() => {
  return take(
    Object.keys(balances.value).filter(
      tokenAddress =>
        Number(balances.value[tokenAddress]) > 0 &&
        tokenAddress !== appNetworkConfig.nativeAsset.address
    ),
    21
  );
});

return (_ctx: any,_cache: any) => {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    square: _unref(upToLargeBreakpoint),
    noPad: "",
    noBorder: _unref(upToLargeBreakpoint),
    growContent: "",
    hFull: _unref(upToLargeBreakpoint),
    shadow: "none",
    chagneType: "trade"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_unref(upToLargeBreakpoint))
            ? (_openBlock(), _createElementBlock("h6", _hoisted_3, _toDisplayString(_ctx.$t('myWallet2')), 1))
            : _createCommentVNode("", true),
          (!_unref(isLoadingBalances))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(etherBalance)) + " " + _toDisplayString(_unref(nativeCurrency)), 1))
            : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                key: 2,
                class: "h-8 w-12"
              }))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_unref(isLoadingBalances))
            ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                key: 0,
                class: "h-8"
              }))
            : (_unref(isWalletReady))
              ? (_openBlock(), _createBlock(_component_BalAssetSet, {
                  key: 1,
                  onClick: _unref(setTokenInAddress),
                  width: 275,
                  wrap: "",
                  size: 32,
                  addresses: _unref(tokensWithBalance),
                  "max-asssets-per-line": 7
                }, null, 8, ["onClick", "addresses"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_BalLink, {
                    onClick: _unref(toggleWalletSelectModal),
                    noStyle: true,
                    class: "dark:text-custom-blue-50"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["square", "noBorder", "hFull"]))
}
}

})